'use client'
import React from 'react'
import { cn } from '../../helpers/utils.js'
import { withLayout } from '../../shared/Styles.js'
import type { SpacerProps } from './types.js'

const Spacer = React.forwardRef<HTMLDivElement, SpacerProps>(({ className, data, ...rest }, ref) => {
  const { space = 'default' } = data
  return (
    <div
      ref={ref}
      {...rest}
      className={cn(
        'ipc_spacer',
        space === 'default' && 'laptop:h-16 desktop:h-[96px] lg-desktop:h-[128px] tablet:h-16 h-16',
        space === 'fixed' && 'h-16',
        className
      )}
    ></div>
  )
})

Spacer.displayName = 'Spacer'

export default withLayout(Spacer)
